/** Kernplaatsen die sitebreed (footer) naar hun stad- en Schipholpagina linken. */
export const FOCUS_PLACE_SLUGS = [
  "rotterdam", "spijkenisse", "capelle-aan-den-ijssel", "schiedam", "vlaardingen", "dordrecht",
  "barendrecht", "hoogvliet-rotterdam", "ridderkerk", "zwijndrecht", "berkel-en-rodenrijs",
  "hellevoetsluis", "krimpen-aan-den-ijssel", "papendrecht", "rhoon", "hendrik-ido-ambacht",
  "den-haag", "poortugaal", "maassluis", "sliedrecht", "alblasserdam", "brielle",
  "nieuwerkerk-aan-den-ijssel", "pijnacker", "bergschenhoek", "oud-beijerland", "rozenburg",
  "pernis-rotterdam", "zevenhuizen", "bleiswijk", "oostvoorne", "delft", "zoetermeer", "strijen",
  "streefkerk", "nieuw-lekkerland", "moordrecht", "zuidland", "krimpen-aan-de-lek", "numansdorp",
  "rockanje", "gouda", "heenvliet", "hardinxveld-giessendam", "puttershoek", "zwartewaal",
  "heerjansdam", "hekelingen", "hoek-van-holland",
] as const;
